// Copyright (c) Docugami, Inc. All rights reserved.

import { dgFontFamily } from 'components/common/Fonts';
import { primaryTheme, themeBlue } from 'components/shell/presentation/AppStyles';
import styled from 'styled-components';

export const DgPill = styled.span<{ fontSize: number, color?: string }>`
    display: inline-block;
    font-family: ${dgFontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: ${props => `${props.fontSize}px`};
    line-height: ${props => `${props.fontSize + 8}px`};
    border-radius: ${props => `${props.fontSize}px`};
    background-color: ${props => props.color ?? themeBlue};
    color: ${primaryTheme.palette.white};
    padding: 0 8px;
`;

// Preview feature pill for ActionTile items
export const TilePill = styled(DgPill)`
    position: absolute;
    top: -10px;
    right: -15px;
`;

export const ActionTilePreviewPill = (): JSX.Element => {
    return <TilePill fontSize={10}>PREVIEW</TilePill>
}